/**
 * PrimaryAttachmentFieldType — F12.B T12.B.3.
 * Pokazuje podgląd głównego załącznika rekordu (read-only w formularzu).
 * Wartość = URL/klucz MinIO, zarządzana przez sekcję załączników rekordu.
 */
import { FileText, Paperclip } from 'lucide-react';

import { FieldRegistry } from '../FieldRegistry';

const IS_IMAGE = /\.(png|jpe?g|gif|webp|svg|bmp)(\?.*)?$/i;
const IS_PDF = /\.pdf(\?.*)?$/i;

FieldRegistry.register({
  type: 'primaryattachment',
  renderInput: ({ value }) => {
    const url = value as string | null;
    if (!url) {
      return (
        <div className="flex flex-col items-center justify-center gap-2 rounded-lg border-2 border-dashed border-border-secondary p-6 text-center">
          <Paperclip className="h-10 w-10 text-text-muted" />
          <p className="text-sm text-text-secondary">Brak głównego załącznika</p>
          <p className="text-xs text-text-tertiary">
            Oznacz załącznik gwiazdką w sekcji załączników
          </p>
        </div>
      );
    }
    if (IS_IMAGE.test(url)) {
      return (
        <img
          src={url}
          alt="Główny załącznik"
          className="max-h-48 w-full max-w-md rounded-lg border border-border-primary object-cover"
        />
      );
    }
    if (IS_PDF.test(url)) {
      return (
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-3 rounded-lg border border-border-primary p-4 hover:bg-bg-secondary transition-colors"
        >
          <FileText className="h-7 w-7 text-danger-500" />
          <span className="text-sm text-accent-600 underline">Otwórz PDF</span>
        </a>
      );
    }
    return (
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-3 rounded-lg border border-border-primary p-4 hover:bg-bg-secondary transition-colors"
      >
        <Paperclip className="h-7 w-7 text-text-muted" />
        <span className="text-sm text-accent-600 underline">Pobierz plik</span>
      </a>
    );
  },
  renderCell: (_field, value) => {
    if (!value) return '—';
    const url = String(value);
    if (IS_IMAGE.test(url)) {
      return (
        <img
          src={url}
          alt=""
          className="h-10 w-10 rounded border border-border-primary object-cover"
        />
      );
    }
    return (
      <div className="flex items-center gap-1.5">
        <Paperclip className="h-3.5 w-3.5 text-text-muted" />
        <span className="max-w-[100px] truncate text-xs text-accent-600">Załącznik</span>
      </div>
    );
  },
  validate: () => null,
  defaultValue: null,
});
